import Cookies from 'js-cookie';
import { v4 as uuidv4 } from 'uuid';

/**
 * Generate and store CSRF token
 * @returns {string} CSRF token
 */
export const generateCSRFToken = () => {
	const token = uuidv4();
	Cookies.set('csrf-token', token, {
		secure: import.meta.env.PROD,
		sameSite: 'strict',
		expires: 1
	});
	return token;
};

/**
 * Get current CSRF token
 * @returns {string|null} CSRF token or null
 */
export const getCSRFToken = () => {
	return Cookies.get('csrf-token');
};

/**
 * Verify CSRF token is present
 * @returns {boolean} Token validity
 */
export const validateCSRFToken = () => {
	const token = getCSRFToken();
	return token && token.length > 0;
};

/**
 * Clear CSRF token (on logout)
 */
export const clearCSRFToken = () => {
	Cookies.remove('csrf-token');
};
